import { TUI_ALERT_POSITION, TuiRoot } from '@taiga-ui/core';
import { Component, inject, Signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ApplicationStore } from '@ffx/app-store';
import { ThemeMode } from '@ffx/common';

@Component({
    standalone: true,
    imports: [RouterModule, TuiRoot],
    providers: [
        {
            provide: TUI_ALERT_POSITION,
            useValue: '4rem auto auto auto' // Top middle of screen
        }
    ],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    private appStore = inject(ApplicationStore);
    title = 'feature-flex';
    theme$: Signal<ThemeMode>;

    constructor() {
        this.theme$ = this.appStore.user.theme;
    }
}
